// extracted by css-extract-rspack-plugin
var _1 = "ig";
var _2 = "if";
var _3 = "gm";
var _4 = "hm";
var _5 = "ie";
var _6 = "e1";
var _7 = "ib";
var _8 = "hq";
var _9 = "ez";
var _a = "f2";
var _b = "hr";
var _c = "ic";
var _d = "as";
var _e = "e0";
export { _1 as "additionalDescription", _2 as "additionalDescriptionContainer", _3 as "banner", _4 as "brandImageBannerComponent", _5 as "caption", _6 as "description", _7 as "imageContainer", _8 as "imageDescription", _9 as "imageLoaderComponent", _a as "linkComponent", _b as "mainContainer", _c as "mobileCaption", _d as "standardContainer", _e as "title" }
